module.exports = __webpack_public_path__ + "static/media/product (11).06eaeb0f.jpg";